import { IWaiter, ITips } from './../model/types'

export const roundFee = (val: number): number => {
  if (val > 0 && val < 20) {
    return Math.ceil(val)
  }

  if (val >= 20 && val < 100) {
    return Math.ceil(val / 5) * 5
  }

  if (val >= 100 && val < 200) {
    return Math.ceil(val / 10) * 10
  }

  if (val >= 200) {
    return 200
  }

  return 0
}

export const isWaiterVerified = (waiter: IWaiter) => {
  return (
    waiter !== undefined &&
    waiter !== null &&
    waiter.name !== null &&
    waiter.waiter_status === 'VERIFIED' &&
    Object.prototype.hasOwnProperty.call(waiter, 'card_verification') &&
    waiter.card_verification
  )
}

export const areTipsActive = (tips: ITips) => {
  return (
    (!tips.hookah || (tips.hookah && tips.hookah.active)) &&
    (!tips.barman || (tips.barman && tips.barman.active)) &&
    (!tips.barista || (tips.barista && tips.barista.active)) &&
    (!tips.sommelier || (tips.sommelier && tips.sommelier.active)) &&
    (!tips.kitchener || (tips.kitchener && tips.kitchener.active)) &&
    (!tips.team || (tips.team && tips.team.active))
  )
}

export const convertRole = (role: string) => {
  switch (role) {
    case 'waiter': return 'официанту'
    case 'hookah': return 'кальянщику'
    case 'kitchener': return 'кухне'
    case 'barman': return 'бармену'
    case 'barista': return 'бариста'
    case 'sommelier': return 'сомелье'
    case 'team': return 'команде'
    default: return ''
  }
}
